@if (number$ | async) {
    <div class="grid-page mx-sm-4 mt-3">
        <dx-tabs
            keyExpr="key"
            [items]="tabs"
            [selectedItemKeys]="[selectedTab]"
            [iconPosition]="'start'"
            (onItemClick)="selectedTab = $event.itemData.key"
            [scrollByContent]="true"
            [scrollingEnabled]="true"
            [showNavButtons]="false"></dx-tabs>
    </div>
}

@if (selectedTab === 'details') {
    <app-order-details [number]="number$ | async"></app-order-details>
} @else if (selectedTab === 'history') {
    <app-order-history [number]="number$ | async"></app-order-history>
}
